import React from 'react';
import clsx from 'clsx';
import type { MusicVideoEffect } from 'fym-shared/src/music24/musicVideoEffects';
import { TypedMemo } from '../../../common/types';
import { effectToneOf, type EffectTone } from './scriptEdits';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the script step; each part uses its own slice of it */
import styles from './Script.module.scss';
/* eslint-enable css-modules/no-unused-class */

const TONE_CLASS: Readonly<Record<EffectTone, string | undefined>> = {
  title: undefined,
  transition: styles.fxChipTransition,
  lyric: styles.fxChipLyric,
  shot: styles.fxChipShot,
};

/** One effect as a chip in its family colour (design `.fxc`). */
const EffectChipComponent: React.FC<{ effect: Pick<MusicVideoEffect, 'kind'>; label: string }> = ({
  effect,
  label,
}) => <span className={clsx(styles.fxChip, TONE_CLASS[effectToneOf(effect)])}>{label}</span>;

export const EffectChip = TypedMemo(EffectChipComponent);
